import { AxiosResponse } from 'axios';
import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Fetch Department
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of departments
 */
export const fetchDepartmentsBySpecialtyData = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Applications/Epic/DepartmentsBySpecialty', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Departments
 * @param {string} queryParam user input
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of departments
 */
export const fetchDepartmentData = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Applications/Epic/Departments/Search', {
			params: {
				search: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch which functional roles should render the target
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of functional roles
 */
export const fetchFunctionalRoleWithApprovalVisibilityRules =
	async dispatch => {
		return await axiosInstance
			.get('api/Applications/Epic/FunctionalRoleWithApprovalVisibility')
			.then(response => then(response, payload => payload, dispatch))
			.catch(ex => {
				throw ex;
			});
	};

/**
 * Fetch Functional Roles
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of functional roles
 */
export const fetchFunctionalRoleData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/FunctionalRoles')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Functional Roles
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of functional roles
 */
export const fetchFunctionalRoleJustificationData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/FunctionalRoleJustifications')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Hospital names
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of hospitals
 */
export const fetchHospitalNameData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/HospitalNames')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Person Metadata for the app
 * @param {string} username target's username
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of target user's metadata
 */
export const fetchPersonMetadata = async (username, dispatch) => {
	return await axiosInstance
		.get('api/Applications/Epic/PersonMetadata', {
			params: {
				username: username,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch Positions
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of positions
 */
export const fetchPositionData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/Positions')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch default position
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<string>>} default position
 */
export const fetchPositionDefaultData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/Positions/default')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch which positions should render the target
 * @param {string} target `EPIC_FIELD_KEYS`
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of positions
 */
export const fetchPositionVisibilityRules = async (target, dispatch) => {
	return await axiosInstance
		.get('api/Applications/Epic/PositionVisibility', {
			params: {
				value: target,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch service areas
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of service areas
 */
export const fetchServiceAreaData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/ServiceAreas')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch specialties
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of specialties
 */
export const fetchSpecialtyData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/Specialties')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch user credentials
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of user credentials
 */
export const fetchUserCredentialData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/UserCredentials')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

/**
 * Fetch User Names
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of user names
 */
export const fetchUsersNameData = async dispatch => {
	return await axiosInstance
		.get('api/Applications/Epic/UserNames')
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};

export const fetchJobCategoryData = async (queryParam, dispatch) => {
	return await axiosInstance
		.get('api/Applications/Epic/JobCategories', {
			params: {
				value: queryParam,
			},
		})
		.then(response => then(response, payload => payload, dispatch))
		.catch(ex => {
			throw ex;
		});
};
